"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _Localization = require("../Localization");
var _components2 = require("../components");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _forms = require("../forms");
var _hooks = require("../hooks");
var _interfaces = require("../interfaces");
var _models = require("../models");
var _api = require("../models/api");
var _utils = require("../utils");
var _virtualPageEventDispatcher = require("../utils/virtualPageEventDispatcher");
var _PendingRegistrationPage = _interopRequireDefault(require("./PendingRegistrationPage"));
var _jsxRuntime = require("react/jsx-runtime");
const StyledWrapForm = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  width: '100%',
  maxWidth: '100%',
  [theme.breakpoints.up('md')]: {
    width: '330px',
    marginRight: theme.spacing(10)
  }
}));
const RootGridContainer = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  backgroundColor: '#fff',
  borderRadius: '15px',
  padding: theme.spacing(10, 0)
}));
const StyledGridForm = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  order: 2,
  paddingInline: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(0),
    order: 1
  }
}));
const StyledGridBenefits = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  order: 1,
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    order: 2
  }
}));
const RegisterPage = ({
  handleCallbackRegistrationId
}) => {
  const {
    registrationID,
    customerReferral,
    autoLoginUrl,
    postLoginRedirectUrl
  } = (0, _contexts.useConfiguration)();
  const intervalState = (0, _react.useRef)();
  const [awaitingRes, setAwaitingRes] = (0, _react.useState)(false);
  const [localPassword, setLocalPassword] = (0, _react.useState)();
  const [isParentalChecked, setIsParentalChecked] = (0, _react.useState)(false);
  const [registrationPendingPage, setRegistrationPendingPage] = (0, _react.useState)(false);
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData,
    data
  } = notificationData;
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep
  } = virtualPageAnalyticsData;
  (0, _react.useEffect)(() => {
    (0, _virtualPageEventDispatcher.virtualPageEventDispatch)('PersonalInfo', undefined);
    setPreviousStep('PersonalInfo');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- virtual page event should be fired exacly once, no need to reevaluate
  }, []);
  const {
    data: config,
    mutate: mutateRefreshMetadata
  } = (0, _globalApiClientReact.useGetCustomerRegistrationInstructionMetadata)(registrationID, undefined, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const isNegativeApprovals = Boolean(config?.legalDetails?.approvals?.shared?.displayAsNegative);
  const {
    data: initialData,
    mutate: mutateGet
  } = (0, _globalApiClientReact.useGetCustomerRegistrationInstruction)(registrationID, undefined, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const {
    handleAutoLogin
  } = (0, _hooks.useAutoLogin)();
  const isSponsorAvailable = config?.sponsorDetails?.sponsorNumber?.isAvailable;
  const isShowEmailVerification = config?.contactDetails?.isEmailVerificationRequired && initialData?.contactDetails?.contactEmail?.value;
  const isShowPhoneVerification = config?.contactDetails?.isTelephoneVerificationRequired && initialData?.contactDetails?.contactTelephone?.value;

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
  const showVerification = isShowEmailVerification || isShowPhoneVerification;
  const requiredVerification =
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
  config?.contactDetails?.isEmailVerificationRequired || config?.contactDetails?.isTelephoneVerificationRequired;
  const {
    mutate: mutateStatus
  } = (0, _api.useCustomerRegistrationInstructionStatus)(status => {
    if (status !== _globalApiClientReact.HttpStatusCodes.status202Accepted) {
      mutateGet();
      clearInterval(intervalState.current);
      setAwaitingRes(false);
    }
    const autoLoginEnabled = status === _globalApiClientReact.HttpStatusCodes.status204NoContent && initialData?.consultantNumber && localPassword;
    if (autoLoginEnabled && !requiredVerification && !isParentalChecked) {
      handleAutoLogin(autoLoginUrl, {
        UserName: initialData.consultantNumber?.toString() ?? '',
        Password: localPassword,
        ReturnUrl: postLoginRedirectUrl ?? '/shopping/basket'
      });
    }
  }, registrationID);
  const api = (0, _globalApiClientReact.useApiClient)();
  const onCreateCustomerRegistrationInstruction = async () => {
    try {
      const CustomerRegistrationInstructionRes = await (0, _globalApiClientReact.createCustomerRegistrationInstruction)(api, {
        registrationType: 'Checkout'
      });
      const result = new _models.FetchResult(CustomerRegistrationInstructionRes.status);
      if (result.isSuccess() && CustomerRegistrationInstructionRes.data) {
        handleCallbackRegistrationId(CustomerRegistrationInstructionRes.data);
      }
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _constants.defaultTranslations.cannotCreate,
          id: _models.TranslationKey.cannotCreate
        }),
        type: _interfaces.MessageType.error
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (!registrationID) {
      onCreateCustomerRegistrationInstruction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- we need every mount
  }, [registrationID]);
  const onGettingStatus = () => {
    clearInterval(intervalState.current);
    const interval = setInterval(() => {
      mutateStatus();
    }, 3000);
    intervalState.current = interval;
    setAwaitingRes(true);
  };
  const handleSubmit = async (data, isCallback) => {
    let corrrectSponsorDetails = {
      sponsorNumber: {
        value: data.sponsorDetails?.sponsorNumber?.value
      },
      sponsorOrigin: {
        value: 'ManualInput'
      },
      invitationCode: data.sponsorDetails?.invitationCode?.value ? {
        value: data.sponsorDetails?.invitationCode?.value
      } : undefined
    };
    if (customerReferral?.ReferralType === 'InternationalPbs' && customerReferral.InternationalPbsCode) {
      corrrectSponsorDetails = {
        internationalPbsCode: {
          value: customerReferral.InternationalPbsCode
        },
        sponsorOrigin: {
          value: customerReferral.ReferralType
        }
      };
    }
    if (customerReferral?.ConsultantNumber && customerReferral.ReferralType) {
      corrrectSponsorDetails = {
        sponsorNumber: {
          value: customerReferral.ConsultantNumber
        },
        sponsorOrigin: {
          value: customerReferral.ReferralType
        }
      };
    }
    const correctBirthDay = data.personalDetails?.birthday?.value ? (0, _utils.rmvTZOffset)(data.personalDetails.birthday.value) : '';
    const correctAddress = data.address ? {
      address: {
        ...data.address,
        // on BE is required, but is possible undefined
        addressType: data.address.addressType ?? 'Other',
        isPrimary: data.address.isPrimary ?? false
      }
    } : null;
    if (data.identityDetails?.password?.value) {
      setLocalPassword(data.identityDetails.password.value);
    }
    const correctParentalConsent = data.parentalConsent && isParentalChecked ? {
      parentalConsent: {
        ...data.parentalConsent,
        isChecked: undefined
      }
    } : {
      parentalConsent: undefined
    };

    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
    const registrationStatusPending = requiredVerification || Boolean(isCallback);
    try {
      if (registrationID) {
        const CustomerRegistrationInstructionRes = await (0, _globalApiClientReact.updateCustomerRegistrationInstruction)(api, registrationID, {
          ...data,
          sponsorDetails: corrrectSponsorDetails,
          registrationId: registrationID,
          personalDetails: data.personalDetails?.lastName?.value ? {
            ...data.personalDetails,
            birthday: correctBirthDay ? {
              value: correctBirthDay
            } : undefined
          } : undefined,
          ...correctAddress,
          ...correctParentalConsent,
          legalDetails: {
            ...data.legalDetails,
            approvals: data.legalDetails?.approvals && (0, _utils.applyNegative)(data.legalDetails.approvals, isNegativeApprovals)
          },
          registrationState: registrationStatusPending ? 'Pending' : 'Submitted'
        });
        const result = new _models.FetchResult(CustomerRegistrationInstructionRes.status);
        if (result.isSuccess()) {
          onGettingStatus();
        }
      }
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _constants.defaultTranslations.cannotCreate,
          id: _models.TranslationKey.cannotCreate
        }),
        type: _interfaces.MessageType.error
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (initialData?.sponsorDetails?.sponsorNumber?.value && !isSponsorAvailable) {
      mutateRefreshMetadata();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- we need every mount and initial data
  }, [initialData?.sponsorDetails]);
  const feedBackIcon = data?.type === _interfaces.MessageType.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckHeavy, {});
  const handleClose = (0, _react.useCallback)(() => {
    setNotificationData({
      isOpen: false
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed updated on other property
  }, [notificationData]);
  const handleParentalConsent = (0, _react.useCallback)(newState => {
    setIsParentalChecked(newState);
  }, []);
  const handleRegistrationPage = (0, _react.useCallback)(newState => {
    setRegistrationPendingPage(newState);
  }, []);
  if (!config) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.Loading, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootGridContainer, {
    container: true,
    justifyContent: "center",
    children: [registrationPendingPage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PendingRegistrationPage.default, {}) : null, showVerification && !registrationPendingPage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.VerificationStep, {
      registrationID: registrationID,
      configContact: config.contactDetails,
      awaitingRes: awaitingRes,
      initialData: initialData,
      userData: {
        userName: initialData.consultantNumber?.toString() ?? '',
        password: localPassword ?? ''
      },
      isParentalConsent: isParentalChecked,
      showRegistrationPage: handleRegistrationPage,
      onSubmitConfirm: () => {
        onGettingStatus();
      }
    }) : null, !showVerification && !registrationPendingPage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.Header, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.General_header,
            id: _models.TranslationKey.General_header
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledGridForm, {
        size: {
          xs: 12,
          md: 6
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapForm, {
          children: [awaitingRes ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.BasicFormSkeleton, {
            skeletonConfig: config
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_forms.RegisterForm, {
            config: config,
            initialData: initialData,
            awaitingRes: awaitingRes,
            refreshMetadata: mutateRefreshMetadata,
            isParentalConsent: handleParentalConsent,
            onSubmitForm: handleSubmit
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledGridBenefits, {
        size: {
          xs: 12,
          md: 6
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.ContentBenefits, {})
      })]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
      open: Boolean(data?.isOpen),
      color: data?.type,
      icon: feedBackIcon,
      onClose: handleClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "translate",
        children: data?.message
      })
    })]
  });
};
var _default = exports.default = RegisterPage;
//# sourceMappingURL=RegisterPage.js.map